import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IDeparmentType } from "src/models/HumanResources/DeparmentTypes.models";

interface DeparmentTypeState {
  deparmentTypes: IDeparmentType[];
  deparmentTypeToEdit: IDeparmentType | null;
}

const initialState: DeparmentTypeState = {
  deparmentTypes: [],
  deparmentTypeToEdit: null,
};

const DeparmentTypeSlice = createSlice({
  name: "DeparmentType",
  initialState,
  reducers: {
    setDeparmentTypeList: (state, action: PayloadAction<IDeparmentType[]>) => {
      state.deparmentTypes = action.payload;
    },
    concatListDeparmentType: (
      state: DeparmentTypeState,
      action: PayloadAction<IDeparmentType[]>
    ) => {
      state.deparmentTypes = [...state.deparmentTypes.concat(action.payload)];
    },
    setDeparmentTypeToEdit: (
      state,
      action: PayloadAction<IDeparmentType | null>
    ) => {
      state.deparmentTypeToEdit = action.payload;
    },
    addDeparmentType: (state, action: PayloadAction<IDeparmentType>) => {
      state.deparmentTypes.push(action.payload);
    },
    updateDeparmentType: (state, action: PayloadAction<IDeparmentType>) => {
      let itemIndex = state.deparmentTypes.findIndex(
        item => item.deparmentTypeId === action.payload.deparmentTypeId
      );
      if (itemIndex !== -1) state.deparmentTypes[itemIndex] = action.payload;
    },
    deleteDeparmentType: (state, action: PayloadAction<number>) => {
      const newArray = state.deparmentTypes.filter(
        item => item.deparmentTypeId !== action.payload
      );
      state.deparmentTypes = newArray;
    },
  },
});

export const {
  setDeparmentTypeList,
  concatListDeparmentType,
  setDeparmentTypeToEdit,
  addDeparmentType,
  updateDeparmentType,
  deleteDeparmentType,
} = DeparmentTypeSlice.actions;

export default DeparmentTypeSlice.reducer;
